import { styled, Tooltip, tooltipClasses, TooltipProps, Typography } from "@mui/material";
import { ReactNode } from "react";

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip enterDelay={500} enterNextDelay={500} {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black
  }
}));

export const TooltipBodyWithHeader = ({ header, body }: { header: ReactNode; body: ReactNode }) => (
  <>
    <Typography variant="subtitle1" sx={{ fontSize: "0.9rem", fontWeight: "500" }}>
      {header}
    </Typography>
    <Typography
      variant="body1"
      sx={{
        whiteSpace: "pre-line",
        fontSize: "0.8rem"
      }}
    >
      {body}
    </Typography>
  </>
);

export { StyledTooltip };
